var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('p',{staticClass:"mt-5"},[_c('b-button',{staticClass:"mr-2",on:{"click":_vm.startCapture}},[_vm._v("starte Bildschirm teilen")]),_c('b-button',{on:{"click":_vm.stopCapture}},[_vm._v("stoppe Bildschirm teilen")])],1),_c('video',{attrs:{"id":"video","autoplay":""}}),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }